import React, { useEffect } from 'react';
import { X, ArrowRight, Link2 } from 'lucide-react';

interface ExAction { cat: '70' | '20' | '10'; text: string; date: string; }
interface ExObj { num: string; title: string; why: string; brecha: string; brechaType: 'weakness' | 'threat' | 'opportunity'; actions: ExAction[]; }

const NORTE = 'Haber consolidado mi posicionamiento como referente de la agenda de transición energética del grupo en LatAm, con la capacidad de sostener conversaciones estratégicas y narrativa de negocio frente al board global.';

const OBJS: ExObj[] = [
  {
    num: '01', title: 'Fortalecer la comunicación estratégica con audiencias no técnicas',
    why: 'Es la brecha más mencionada en mis evaluaciones y la que más limita mi proyección al board global.',
    brecha: 'Comunicación con ejecutivos no técnicos del grupo', brechaType: 'weakness',
    actions: [
      { cat: '70', text: 'Liderar la presentación del plan LatAm ante el board global de Tokio', date: 'Abr 2026' },
      { cat: '70', text: 'Presentar el modelo de costo unitario al comité ejecutivo regional', date: 'Jun 2026' },
      { cat: '20', text: 'Sesiones de coaching de storytelling ejecutivo con mi mentor', date: 'Mar 2026' },
      { cat: '10', text: 'Curso de comunicación estratégica para líderes', date: 'May 2026' },
    ],
  },
  {
    num: '02', title: 'Ampliar mi exposición internacional para una posición regional',
    why: 'Sin responsabilidad fuera de Perú, una posición regional puede leerse como falta de versatilidad.',
    brecha: 'Posición regional Andina en horizonte 2026', brechaType: 'opportunity',
    actions: [
      { cat: '70', text: 'Tomar responsabilidad directa en un proyecto en Chile o Argentina', date: 'Jul 2026' },
      { cat: '20', text: 'Shadowing con el GG Regional Andino', date: 'Ago 2026' },
      { cat: '10', text: 'Programa de liderazgo regional del grupo', date: 'Sep 2026' },
    ],
  },
];

const CAT = { '70': { label: 'EXP · 70', color: '#A50D27' }, '20': { label: 'OTROS · 20', color: '#0F4E8A' }, '10': { label: 'FORMAL · 10', color: '#1F6F4A' } };

const PdiExampleModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [onClose]);

  return (
    <div className="pdi-ex-overlay" onClick={onClose}>
      <div className="pdi-ex-modal" onClick={e => e.stopPropagation()}>
        <button className="pdi-ex-close" onClick={onClose} title="Cerrar (Esc)"><X size={18} /></button>
        <div className="pdi-ex-kicker">Referencia</div>
        <h2 className="pdi-ex-title">Ejemplo de <span>PDI</span></h2>
        <p className="pdi-ex-intro">
          Cómo se ve un Plan de Desarrollo Individual bien construido: un norte claro, objetivos ligados a brechas del
          FODA y acciones concretas balanceadas con el modelo 70/20/10. <strong>El tuyo no tiene que verse igual</strong> —
          solo tener el mismo nivel de concreción.
        </p>

        <div className="pdi-ex-seclabel">01 · Tu norte</div>
        <div className="pdi-ex-norte">{NORTE}</div>

        <div className="pdi-ex-seclabel">02 · Objetivos</div>
        {OBJS.map(o => (
          <div className="pdi-ex-obj" key={o.num}>
            <div className="pdi-ex-obj-top">
              <div className="pdi-ex-obj-num">Objetivo {o.num}</div>
              <div className="pdi-ex-obj-title">{o.title}</div>
              <div className="pdi-ex-obj-why">{o.why}</div>
            </div>
            <div className={`pdi-ex-linked ${o.brechaType}`}>
              <Link2 size={12} /> <span className="pdi-ex-linked-label">Brecha</span> {o.brecha}
            </div>
            <div className="pdi-ex-actions">
              {o.actions.map((a, i) => (
                <div className="pdi-ex-action" key={i}>
                  <span className="pdi-ex-action-cat" style={{ background: CAT[a.cat].color }}>{CAT[a.cat].label}</span>
                  <span className="pdi-ex-action-text">{a.text}</span>
                  <span className="pdi-ex-action-date">{a.date}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="pdi-ex-foot">
          <button className="foda-btn foda-btn--ink" onClick={onClose}>Volver a mi PDI <ArrowRight size={16} /></button>
        </div>
      </div>
    </div>
  );
};

export default PdiExampleModal;
